// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"a80e9e94","573":"69a8d1b1","651":"132128a0","689":"1a9cefeb","708":"ffc6a318","974":"e9e3131b"}[chunkId] + ".chunk.js";
};